module.exports = __webpack_public_path__ + "static/media/bib_organizer.43f56a29.png";